<div id="main">
  <div id="table">
    <app-energies-table> </app-energies-table>
  </div>
</div>
